export const STRIPE_TIERS = {
  free: {
    name: "Free",
    price: 0,
    price_id: null,
    product_id: null,
    limits: {
      projects: 2,
      validationsPerMonth: 3,
    },
    featureFlags: {
      financialModeling: false,
      fullCompetitors: false,
      regulatoryRisk: false,
      complianceRoadmap: false,
      pdfExport: false,
      prioritySupport: false,
      gtmStrategy: false,
    },
    features: [
      "2 projects",
      "3 AI validations / month",
      "Viability score breakdown",
      "Basic market sizing",
      "Top 3 competitors",
    ],
  },
  pro: {
    name: "Pro",
    price: 29,
    price_id: "price_1TB016LZBG5WAbXfoHjBbBfk",
    product_id: "prod_U9IcxkFfytrTcM",
    limits: {
      projects: 5,
      validationsPerMonth: 15,
    },
    featureFlags: {
      financialModeling: true,
      fullCompetitors: true,
      regulatoryRisk: true,
      complianceRoadmap: false,
      pdfExport: true,
      prioritySupport: false,
      gtmStrategy: true,
    },
    features: [
      "5 projects",
      "15 AI validations / month",
      "Score breakdown & recommendations",
      "Financial modeling",
      "Full competitor intel",
      "Regulatory risk scan",
      "PDF export",
    ],
  },
  business: {
    name: "Business",
    price: 79,
    price_id: "price_1TB017LZBG5WAbXfJy1uzJOW",
    product_id: "prod_U9Ic6eC634KTcM",
    limits: {
      projects: Infinity,
      validationsPerMonth: Infinity,
    },
    featureFlags: {
      financialModeling: true,
      fullCompetitors: true,
      regulatoryRisk: true,
      complianceRoadmap: true,
      pdfExport: true,
      prioritySupport: true,
      gtmStrategy: true,
    },
    features: [
      "Unlimited projects",
      "Unlimited AI validations",
      "Score breakdown & recommendations",
      "Financial modeling",
      "Full competitor intel",
      "Regulatory risk scan",
      "Compliance roadmap",
      "PDF export",
      "Priority support",
    ],
  },
} as const;

export type TierKey = keyof typeof STRIPE_TIERS;

export function getTierByProductId(productId: string | null): TierKey {
  if (!productId) return "free";
  for (const [key, tier] of Object.entries(STRIPE_TIERS)) {
    if (tier.product_id === productId) return key as TierKey;
  }
  return "free";
}

export function hasFeature(tier: TierKey, feature: keyof typeof STRIPE_TIERS.free.featureFlags): boolean {
  return STRIPE_TIERS[tier].featureFlags[feature];
}
